import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'web-design-system-pill',
  templateUrl: './pill.component.html',
  styleUrl: './pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class PillComponent {
  @Input() public type: 'new' | 'default' | 'grey' = 'default';
  @Input() public size: 'sm' | 'md' = 'md';
}
